import React, { useState, useEffect } from 'react';
import {
  Container, Image, Menu,
  Segment,
  Sidebar, Icon,
  Button,
  Header,
  Message
} from 'semantic-ui-react';
import { useAuth } from "../App";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from '../components/LoadingSpinner';
import { useIsMobile } from '../utils/hooks';
import { trackPageView } from '../utils/analytics';
import { LogoutDialog } from '../components/dialog/LogoutDialog';
import { BackgroundContainer } from '../components/BackgroundContainer';

const ManagementPage = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [sidebarOpened, setSidebarOpened] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [active, setActive] = useState('users');

  const isMobile = useIsMobile();

  const isUserManager = (user) => {
    //TODO: add role controle
    return user.email === 'kontaktujmademo@gmail.com';
  }

  useEffect(() => {
    if (loading) { return; }
    if (!user || !user.email || !isUserManager(user)) {
      navigate("/");
      return;
    }
    const url = document.location.pathname + document.location.search;
    trackPageView(url);

  }, user);

  if (!user || !user.email || !user.data) {
    return <LoadingSpinner />
  }

  const renderHeader = () => {
    if (active === 'users') return 'POUŽÍVATELIA';
    if (active === 'settings') return 'NASTAVENIA';
  }

  return (
    <BackgroundContainer>
      <LogoutDialog
        setLogoutOpen={setLogoutOpen}
        logoutOpen={logoutOpen}
        user={user}
      />
      <>
        {!isMobile ? (
          // --- Desktop Menu ---
          <Menu fixed="top" inverted pointing stackable>
            <Container>
              <Menu.Item as="a" header onClick={() => navigate("/")} style={{ marginTop: '1rem', marginBottom: 12 }}>
                <Image
                  size="small"
                  src="../landing/assets/img/navbar-logo2.svg"
                  style={{ marginRight: '1.5em' }}
                />
              </Menu.Item>
              <div style={{ width: "100%", display: 'flex', justifyContent: 'end' }}>
                <Menu.Item
                  as="a"
                  onClick={() => {
                    setLogoutOpen(true);
                  }}
                >
                  Odhlásiť
                </Menu.Item>
                <Menu.Item
                  as="a"
                  header
                >
                  Prihlásený: {user.email}
                </Menu.Item>
              </div>
            </Container>
          </Menu>
        ) : (
          <>
            {/* --- Mobile Trigger --- */}
            <Menu style={{ marginRight: '1rem', marginTop: '1rem' }} fixed="top" inverted pointing secondary>
              <Container>
                <Menu.Item position="right">
                  <Image
                    size="small"
                    src="../landing/assets/img/navbar-logo2.svg"
                    style={{ marginRight: '1rem' }}
                    onClick={() => navigate("/")}
                  />
                  <Button icon inverted onClick={() => setSidebarOpened(true)}>
                    <Icon name="bars" />
                  </Button>
                </Menu.Item>
              </Container>
            </Menu>

            {/* --- Sidebar Snackbar --- */}
            <Sidebar
              as={Menu}
              animation="overlay"
              onHide={() => setSidebarOpened(false)}
              vertical
              visible={sidebarOpened}
              inverted
            >
              <Menu.Item as="a" header>
                <Segment inverted>
                  Prihlásený: {user.email}
                </Segment>
              </Menu.Item>
              <Menu.Item
                as="a"
                active={active === 'logout'}
                onClick={() => {
                  setLogoutOpen(true);
                }}
              >
                Odhlásiť
              </Menu.Item>
            </Sidebar>
          </>
        )}
      </>

      <div style={{ height: '80vh' }}>
        <Container textAlign='center'>
          <Header style={{ color: 'white', margin: '2rem', marginTop: '1rem' }}>{renderHeader()}</Header>
        </Container>
        <Message>Hello Manager!!!</Message>
      </div>
    </BackgroundContainer>
  );
};

export default ManagementPage;